import { Injectable } from '@angular/core';
import { APP_CONFIG } from 'app.config';
import { AppState } from 'app/shared/common/utils/AppState';
import { HttpHelper } from 'app/shared/common/utils/http/HttpHelper';
import { AgGridWithoutCacheService } from 'app/shared/components/base/ag-grid-without-cache/ag-grid-without-cache.service';

@Injectable()
export class WorkflowMyTaskService extends AgGridWithoutCacheService {

    constructor(private _httpHelper: HttpHelper,
        public _appState: AppState) {
        super(_httpHelper, _appState)
    }

    public pivotPaging(request: any): Promise<any> {
        const url = `${APP_CONFIG.MCRHRRCRT}requisition/pivotPagingAssignedTasks`;
        return this._httpHelper.methodPostService(url, request);
    }

    public pivotCount(request: any): Promise<any> {
        const url = `${APP_CONFIG.MCRHRRCRT}requisition/pivotCountAssignedTasks`;
        return this._httpHelper.methodPostService(url, request);
    }
}
